<template lang="pug">
  v-form(id="dynamic-form")
    h2(class="new-advert-subtitle mb-2" v-if="differentTypesItems.length") Подробнее:
    v-row(justify="start", v-for="item in differentTypesItems", :key="item.key")
      v-col(cols="2",
        :class="(item.type !== 'numValues' && item.type !== 'enum') ? 'd-flex align-center label-text' : 'label-text'") {{ item.name }}
      // v-col(cols="4", v-if="item.type === 'string'")
        v-text-field(
          outlined,
          dense,
          clearable,
          hide-details,
          // :placeholder="`Укажите ${item.name}`",
          v-model="detailFields[item.key]")
      v-col(cols="4" v-if="item.type === 'int' || item.type === 'double'", class="pt-2")
        v-text-field(
          dense,
          outlined,
          clearable,
          hide-details,
          :placeholder="`Укажите ${item.name}`",
          v-model.number="detailFields[item.key]")
      v-col(cols="10", v-if="item.type === 'numValues'", class="pt-0")
        v-chip-group(
          column,
          v-model="detailFields[item.key]")
          v-chip(
            class="px-4",
            outlined,
            v-for="(val, index) in item.numValues",
            :key="index",
            :value="val.key") {{ val.text }}
      v-col(cols="10", v-if="item.type === 'enum'", class="pt-0")
        v-chip-group(
          column,
          v-model="detailFields[item.key]")
          v-chip(
            class="px-4",
            outlined,
            v-for="(val, index) in item.enumValues",
            :key="index",
            :value="val.key") {{ val.text }}
    h2(class="new-advert-subtitle mb-6 mt-6" v-if="booleanTypesItems.length") Удобства и подробности:
    v-row(no-gutters)
      v-btn-toggle(v-model="extraDetailFields", class="fields", multiple)
        v-btn(
          v-for="item in booleanTypesItems"
          :key="item.key"
          :value="item.key") {{ item.name }}
</template>

<script>
export default {
  name: 'DynamicItems',
  props: {
    advertType: {
      type: String
    },
    items: {
      type: Array
    }
  },
  data: () => ({
    booleanTypesItems: [],
    differentTypesItems: [],
    detailFields: {},
    extraDetailFields: []
  }),
  watch: {
    items: {
      immediate: true,
      handler(values) {
        this.booleanTypesItems = []
        this.differentTypesItems = []
        if (values.length) {
          values.map(item => {
            if (item.type === 'bool') this.booleanTypesItems.push(item)
            else {
              if (item.type !== 'string') this.differentTypesItems.push(item)
            }
          })
        }
      }
    },
    detailFields(val) {
      this.$emit('set-fields', val)
    },
    extraDetailFields(val) {
      this.$emit('set-extra-fields', val)
    },
    advertType() {
      this.clearData()
    }
  },
  methods: {
    clearData() {
      this.booleanTypesItems = []
      this.differentTypesItems = []
      this.detailFields = {}
      this.extraDetailFields = []
    }
  }
}
</script>

<style scoped lang="scss">
.label-text {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.629525px;
  color: #000000;
}
#dynamic-form {
  .v-chip-group {
    .v-chip {
      color: #8e8e93 !important;
      background: #e5e5ea !important;
      border-color: transparent;
      &.v-chip--active {
        background-color: #07f !important;
        color: #fff !important;
        border-color: transparent;
      }
    }
  }
  .v-text-field {
    &__slot {
      input {
        font-size: 12px !important;
      }
    }
  }
  .fields {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .v-btn {
      width: 200px !important;
      height: 80px !important;
      border-radius: 6px !important;
      border: none !important;
      background-color: #fff !important;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
      color: #8e8e93 !important;
      font-weight: 700;
      margin-bottom: 22px;
      margin-right: 32px;
      &--active {
        color: #fff !important;
        background-color: #07f !important;
        opacity: 1 !important;
        box-shadow: none;
        &:before {
          opacity: 0 !important;
        }
      }
    }
  }
}
</style>
